export const getOperatingSystem = () => {
  const platform = window.navigator?.platform;
  if (platform.indexOf('Win') !== -1) {
    return 'Window';
  }
  if (platform.indexOf('Mac') !== -1) {
    return 'MacOS';
  }
  if (platform.indexOf('Linux') !== -1) {
    return 'Linux';
  }
  return null;
};
